"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.uploadProfileImage = exports.uploadCompanyContent = exports.signProfileContent = exports.signCompanyContent = exports.reducer = exports.bumpProfileKey = exports.LOAD = exports.ACTION = void 0;

var _api = _interopRequireWildcard(require("@aws-amplify/api"));

var _loader = _interopRequireDefault(require("./loader"));

var _dayjs = _interopRequireDefault(require("dayjs"));

var queries = _interopRequireWildcard(require("./../gql/queries"));

var _buffer = require("buffer");

var _axios = _interopRequireDefault(require("axios"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/**
 * List of action strings
 *
 * @type {object}
 */
var ACTION = {
  BUMP_PROFILE_KEY: 'bump-profile-key',
  SIGN_PROFILE_CONTENT: 'sign-profile-content',
  SIGN_COMPANY_CONTENT: 'sign-company-content',
  UPLOAD_PROFILE_IMAGE: 'upload-profile-image',
  SET_UPLOAD_URL: 'set-upload-url',
  UPLOAD_COMPANY_CONTENT: 'upload-company-content'
};
/**
 * List of loading action strings
 *
 * @type {object}
 */

exports.ACTION = ACTION;

var LOAD = _objectSpread({}, ACTION);
/**
 * Wrapper function. Checks if content has been signed
 * recently.
 */


exports.LOAD = LOAD;

var checkExpiration = function checkExpiration(signed, cb) {
  var cfExpires = signed.cfExpires; // Add a 20 second buffer. If signed content has yet to expire, just
  // ignore this and don't sign content again.

  if ((0, _dayjs["default"])().unix() < cfExpires - 20) return Promise.resolve(signed);
  return cb();
};
/**
 * Generate signed cookies for company content
 *
 * @return {Promise}
 */


var signCompanyContent = function signCompanyContent() {
  return function (dispatch, getState) {
    var _getState = getState(),
        signed = _getState.signed;

    return checkExpiration(signed.company, function () {
      return _loader["default"].load(LOAD.SIGN_PROFILE_CONTENT, function (dispatch) {
        return _api["default"].graphql((0, _api.graphqlOperation)(queries.signCompanyContent)).then(function (result) {
          dispatch({
            type: ACTION.SIGN_COMPANY_CONTENT,
            data: result.data.signCompanyContent
          });
          return result.data.signCompanyContent;
        });
      })(dispatch, getState);
    });
  };
};
/**
 * Generate signed cookies for displaying
 * profile picture content for a user.
 *
 * @return {Promise}
 */


exports.signCompanyContent = signCompanyContent;

var signProfileContent = function signProfileContent() {
  return function (dispatch, getState) {
    var _getState2 = getState(),
        signed = _getState2.signed;

    return checkExpiration(signed.profile, function () {
      return _loader["default"].load(LOAD.SIGN_PROFILE_CONTENT, function (dispatch) {
        return _api["default"].graphql((0, _api.graphqlOperation)(queries.signProfileContent)).then(function (result) {
          return dispatch({
            type: ACTION.SIGN_PROFILE_CONTENT,
            data: result.data.signProfileContent
          });
        });
      })(dispatch, getState);
    });
  };
};
/**
 * Bump the profile picture version key. This is used
 * for cache busting purposes.
 */


exports.signProfileContent = signProfileContent;

var bumpProfileKey = function bumpProfileKey() {
  return {
    type: ACTION.BUMP_PROFILE_KEY
  };
};
/**
 * Generate signed cookies for company content
 *
 * @return {Promise}
 */


exports.bumpProfileKey = bumpProfileKey;

var uploadCompanyContent = function uploadCompanyContent(contentType, data, key) {
  return _loader["default"].load(LOAD.SIGN_PROFILE_CONTENT, function (dispatch) {
    return _api["default"].graphql((0, _api.graphqlOperation)(queries.getCompanyUploadUrl, {
      contentType: contentType,
      key: key
    })).then(function (result) {
      return result.data.getCompanyUploadUrl.url;
    }).then(function (url) {
      return _axios["default"].put(url, data, {
        headers: {
          'Content-Type': contentType
        }
      });
    });
  });
};
/**
 * Upload a new profile picture. Generates a new upload
 * URL if needed.
 */


exports.uploadCompanyContent = uploadCompanyContent;

var uploadProfileImage = function uploadProfileImage(contentType, data) {
  // Add 20 second buffer for upload times
  var check = (0, _dayjs["default"])().add(20, 'seconds').unix();
  return _loader["default"].load(LOAD.UPLOAD_PROFILE_IMAGE, function (dispatch, getState) {
    var profile = getState().signed.profile;
    var url = null;
    return Promise.resolve().then(function () {
      if (profile.uploadUrls[contentType] && profile.uploadUrls[contentType].expires > check) {
        return profile.uploadUrls[contentType];
      } else {
        return _api["default"].graphql((0, _api.graphqlOperation)(queries.getProfileUploadUrl, {
          contentType: contentType
        })).then(function (result) {
          // Dispatch so we can store it in context
          dispatch({
            type: ACTION.SET_UPLOAD_URL,
            contentType: contentType,
            data: result.data.getMe.profileUploadUrl
          }); // Return for immediate use

          return result.data.getMe.profileUploadUrl;
        });
      }
    }).then(function (url) {
      return Promise.resolve() // Execute upload request
      .then(function () {
        return _axios["default"].put(url.url, _buffer.Buffer.from(data, 'base64'), {
          headers: {
            'Content-Type': contentType
          }
        });
      }) // Re-render profile image
      .then(function () {
        return dispatch(bumpProfileKey());
      });
    });
  });
};
/**
 * Initial reducer state
 * @type {object}
 */


exports.uploadProfileImage = uploadProfileImage;
var initial = {
  profile: {
    cfPolicy: null,
    cfSignature: null,
    cfKeyPairId: null,
    cfExpires: null,
    key: (0, _dayjs["default"])().unix(),
    uploadUrls: {}
  },
  company: {
    cfPolicy: null,
    cfSignature: null,
    cfKeyPairId: null,
    cfExpires: null
  }
};

var reducer = function reducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initial;
  var action = arguments.length > 1 ? arguments[1] : undefined;

  switch (action.type) {
    case ACTION.SIGN_PROFILE_CONTENT:
      return _objectSpread(_objectSpread({}, state), {}, {
        profile: _objectSpread(_objectSpread({}, state.profile), action.data)
      });

    case ACTION.SIGN_COMPANY_CONTENT:
      return _objectSpread(_objectSpread({}, state), {}, {
        company: action.data
      });

    case ACTION.BUMP_PROFILE_KEY:
      return _objectSpread(_objectSpread({}, state), {}, {
        profile: _objectSpread(_objectSpread({}, state.profile), {}, {
          key: state.profile.key + 1
        })
      });

    case ACTION.SET_UPLOAD_URL:
      return _objectSpread(_objectSpread({}, state), {}, {
        profile: _objectSpread(_objectSpread({}, state.profile), {}, {
          uploadUrls: _objectSpread(_objectSpread({}, state.profile.uploadUrls), {}, _defineProperty({}, action.contentType, action.data))
        })
      });

    default:
      return state;
  }
};

exports.reducer = reducer;